import useBodyScrollLock from '@hooks/useBodyScrollLock';
import SvgChevron from '@img/icons/nav-chevron.svg';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './MobileNavigation.styles';
import { linkAria } from '@helpers/utils';
const MobileNavigation = (props) => {
    const ref = useBodyScrollLock(props.isActive);
    const [stack, setStack] = React.useState([]);
    // Reset state if navigation is toggled.
    React.useEffect(() => {
        if (props.isActive) {
            setStack([]);
        }
    }, [props.isActive]);
    // Render top level navigation...
    if (stack.length === 0) {
        return renderDefault();
    }
    // ...or current level.
    return renderLevel(stack[stack.length - 1]);
    /**
     * Render the top-level layout.
     * @returns
     */
    function renderDefault() {
        return (React.createElement(S.Container, { ref: ref, "data-m-active": props.isActive, "aria-hidden": !props.isActive, "aria-label": "Main Navigation - Mobile" },
            React.createElement(S.List, null, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
                React.createElement(S.Link, { "aria-label": linkAria(item.title, item.target, props.translations && props.translations['lcci.link.newtab']), href: item.url, tabIndex: props.isActive ? undefined : -1, target: item.target, onClick: (event) => {
                        if (item.children) {
                            event.preventDefault();
                            push(item);
                        }
                    } },
                    React.createElement(S.Text, null, item.title),
                    !!item.children?.length && React.createElement(S.Arrow, { as: SvgChevron })))))),
            props.loggedIn ? (React.createElement(S.MemberMenu, null, props.memberNav.map((item) => (React.createElement("li", { key: item.text },
                React.createElement(S.MemberLink, { "aria-label": linkAria(item.text ?? '', item.target, props.translations && props.translations['lcci.link.newtab']), href: item.url, target: item.target ? item.text : '_parent', tabIndex: props.isActive ? undefined : -1 }, item.text)))))) : (React.createElement(S.CtaWrapper, null,
                React.createElement(LinkButton, { buttonType: "blue-outline", "aria-label": linkAria(props.cta1.text ?? '', props.cta1.target, props.translations && props.translations['lcci.link.newtab']), href: props.cta1.url, target: props.cta1.target, icon: 'account', tabIndex: props.isActive ? undefined : -1 }, props.cta1.text),
                props.cta2 && (React.createElement(LinkButton, { buttonType: "orange-solid", "aria-label": linkAria(props.cta2.text ?? '', props.cta2.target, props.translations && props.translations['lcci.link.newtab']), href: props.cta2.url, target: props.cta2.target, icon: 'star', tabIndex: props.isActive ? undefined : -1 }, props.cta2.text))))));
    }
    /**
     * Render the layout for the current active item (last in stack).
     * @returns
     */
    function renderLevel(activeItem) {
        const items = activeItem.children ?? [];
        const hasThirdLevel = items.some((item) => !!item.children?.length);
        return (React.createElement(S.Container, { ref: ref, "data-m-active": props.isActive, "data-third": hasThirdLevel },
            React.createElement(S.Header, null,
                React.createElement(S.Back, { onClick: (event) => {
                        event.preventDefault();
                        pop();
                    } },
                    React.createElement(SvgChevron, null),
                    React.createElement("span", null, "Back"))),
            hasThirdLevel ? (React.createElement(S.GroupList, null, items.map((item) => (React.createElement(S.Group, { key: item.id },
                React.createElement(S.GroupTitle, null, item.title),
                item.children && (React.createElement(S.List, null, item.children.map((item) => (React.createElement(S.Item, { key: item.id, "data-summary": !!item.summary },
                    React.createElement(S.Link, { "aria-label": linkAria(item.title ?? '', item.target, props.translations && props.translations['lcci.link.newtab']), href: item.url, target: item.target },
                        React.createElement(S.Text, null, item.title),
                        item.summary && React.createElement(S.Summary, null, item.summary)))))))))))) : (React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id, "data-summary": !!item.summary },
                React.createElement(S.Link, { "aria-label": linkAria(item.title ?? '', item.target, props.translations && props.translations['lcci.link.newtab']), href: item.url, target: item.target },
                    React.createElement(S.Text, null, item.title),
                    item.summary && React.createElement(S.Summary, null, item.summary)))))))));
    }
    /**
     * Push navigation item to stack.
     * @param item
     */
    function push(item) {
        const newStack = [...stack, item];
        setStack(newStack);
    }
    /**
     * Pop last item from stack.
     * @param item
     */
    function pop() {
        const newStack = stack.slice(0, stack.length - 1);
        setStack(newStack);
    }
};
export default MobileNavigation;
